<template>
<div class="nj-flex">
    <b-upload v-model="document" @input="input($event)">
        <div class="nj-button">
            <i class="mdi-attachment"></i>
            {{ label }}
        </div>
    </b-upload>
    <Button title="Remover adjunto" color="red" icon="remove" v-if="document" @click="remove()"></Button>
</div>
</template>
<script>
import Button from "./Button.vue"

export default {
    name: "Upload",
    components: {
        Button
    },
    props: {
        value: null,
        text: {
            type: String,
            default: "Adjuntar"
        },

    },
    data() {
        return {
            document: null
        }
    },
    watch: {
        value(newValue) {
            this.document = newValue
        }
    },
    computed: {
        label() {
            if (this.document) {
                return this.document.name
            }
            else {
                return this.text
            }
        },
    },
    methods: {
        input(document) {
            this.document = document
            this.$emit("input", document)
        },
        remove() {
            this.document = null
            this.$emit("input", this.document)
        },
    },
    mounted() {

    }
}
</script>

<style scoped>
.nj-upload {
    display: flex;
    gap: 0;
}
</style>